import React from "react";
import CommonButton from "../../common/components/Buttons/CommonButton";
import DatePickerField from "../../common/components/FormFields/DatePickerFieldNew";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import DropdownField from "../../common/components/FormFields/DropdownField";
import { getDailyCollection } from "../services/dailycollectionreport/DailyCollectionReportServices";
import { errorAlert } from "../../common/components/Toasts/CustomToasts";

// onClick={async () => {
//     const payload = {
//         fromDate:
//             fromDateValue !== null
//                 ? format(new Date(fromDateValue), "yyyy-MM-dd")
//                 : null,
//         toDate:
//             toDateValue !== null
//                 ? format(new Date(toDateValue), "yyyy-MM-dd")
//                 : null,
//     };

//     try {
//         const response = await fetch("/api/daily-collection-report", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(payload),
//         });

//         const blob = await response.blob(); // PDF comes as blob
//         const url = window.URL.createObjectURL(blob);
//         setPdfUrl(url); // store for rendering
//     } catch (error) {
//         console.error("Error fetching PDF:", error);
//     }
// }}


// {pdfUrl && (
//     <div className="mt-4 w-full h-[600px] border">
//         <iframe
//             src={pdfUrl}
//             title="Daily Collection Report"
//             width="100%"
//             height="100%"
//         />
//     </div>
// )}


// onClick={() => {
//     reset(defaultValues);
//     setPdfUrl(null);
// }}

// const response = await axios.post("/api/daily-collection-report", payload, {
//     responseType: "blob",
// });
export default function DailyCollectionReport() {

    const defaultValues = {
        fromDate: null,
        toDate: null,
        userId: null,
        unitId: null,
        opdIpd: 0
    };

    const { control, watch, reset } = useForm({
        mode: "onChange",
        defaultValues,
    });

    const fromDateValue = watch("fromDate")
    const toDateValue = watch("toDate")
    const [dailyReport, setDailyReport] = React.useState(null)
    function handleDailyCollection() {
        let postobj = {
            fromDate: fromDateValue ? format(new Date(fromDateValue), "yyyy-MM-dd") : null,
            toDate: toDateValue ? format(new Date(toDateValue), "yyyy-MM-dd") : null,
            userId: null,
            unitId: null,
            opdIpd: 0
        };

        getDailyCollection(postobj, {
            responseType: "blob"   // ✅ VERY IMPORTANT
        })
            .then((response) => {

                console.log("Content-Type:", response.headers["content-type"]);
                console.log("Blob size:", response.data.size);

                // ✅ Create proper PDF blob
                const blob = new Blob([response.data], {
                    type: "application/pdf",
                });

                const url = window.URL.createObjectURL(blob);

                console.log("PDF URL:", url);

                // ✅ Set state
                setDailyReport({
                    blob: blob,
                    url: url
                });

                // ✅ Optional debug (open in new tab)
                // window.open(url);

            })
            .catch((error) => {
                console.error("Error loading report:", error);
            });
    }


    return (<>
        <h1 className=" my-2 font-semibold whitespace-nowrap text-base tracking-wide pt-10">
            Daily Collection Report
        </h1>
        <div className="flex space-x-3 items-center w-full ">

            <div>
                <DatePickerField
                    name="fromDate"
                    control={control}
                    label="From Date"
                    inputFormat="dd-MM-yyyy"
                />
            </div>
            <div>
                <DatePickerField
                    name="toDate"
                    control={control}
                    label="To Date"
                    inputFormat="dd-MM-yyyy"
                />
            </div>
            <div className="w-32"><DropdownField control={control} name="user" label="User" placeholder={"User"} isClearable={true} isSearchable={true} /></div>

            <div>
                <CommonButton
                    type="button"
                    label="Reset"
                    className="border border-customRed text-customRed"
                    onClick={() => {
                        reset(defaultValues);
                        setDailyReport(null)
                    }}
                />
            </div>
            <div>
                <CommonButton
                    searchIcon={true}
                    type="button"
                    className="bg-customBlue text-white h-9"
                    onClick={handleDailyCollection}
                />
            </div>
        </div>
        <div className="mt-4 w-full h-[80vh] border">
            {dailyReport?.url && (
                <iframe
                    src={dailyReport.url}
                    width="100%"
                    height="600px"
                    title="Daily Report PDF"
                />
            )}


        </div>


    </>)
}